export const FLOATING_COLOR_SWATCHES = 'color-picker-floating-color-swatches';
export const RESET_BUTTON = 'color-picker-reset-button';
